"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts a Slate rich text document into
 * plain text.
 *
 * @param richText The Slate document.
 */
function convertToPlainText(richText) {
    if (!richText) {
        return '';
    }
    var plainText = richText.reduce(function (partialText, block) {
        var newText = partialText;
        if (![
            'image-linked',
            'image',
            'audio',
            'video',
            'tex',
            'image-uploaded',
            'media',
        ].includes(block.type)) {
            block.children.forEach(function (leaf) {
                if (leaf.type === 'equation') {
                    newText += leaf.tex;
                }
                else {
                    newText += leaf.text;
                }
            });
        }
        if (block.type === 'tex') {
            newText += " " + block.tex;
        }
        newText += ' ';
        return newText;
    }, '');
    return plainText;
}
exports.default = convertToPlainText;
//# sourceMappingURL=convertToPlainText.js.map